//import { Description } from "@mui/icons-material";
import primeiraetapa from "assets/images/etapa1.jpg";
import segundaetapa from "assets/images/etapa2.jpg";
import terceiraetapa from "assets/images/etapa3.jpg";
import quartaetapa from "assets/images/etapa4.jpg";
import quintaetapa from "assets/images/etapa5.jpg";

export default [
  {
    title: "Etapas",
    items: [
      {
        image: primeiraetapa,
        name: "1º",
      },
      {
        image: segundaetapa,
        name: "2º",
      },
      {
        image: terceiraetapa,
        name: "3º",
      },
      {
        image: quartaetapa,
        name: "4º",
      },
      {
        image: quintaetapa,
        name: "5º",
      },
    ],
  },
];
